import { render, staticRenderFns } from "./IndividualModerationView.vue?vue&type=template&id=74cc7749"
import script from "./IndividualModerationView.vue?vue&type=script&lang=js"
export * from "./IndividualModerationView.vue?vue&type=script&lang=js"
import style0 from "./IndividualModerationView.vue?vue&type=style&index=0&id=74cc7749&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports